module.exports = __webpack_public_path__ + "static/treasure-box.5bd5161b.png";